// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
      //suggestionMode: 'test'
      //suggestionPosition: 'left',
      suggestionWidth: 300,
  }
};

(function () {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
    if(!suggestionElement) suggestionElement = this.suggestionElement;
    if(!searchElement) searchElement = this.searchElement;
    if(!searchBoxId) searchBoxId = this.searchBoxId;
  };

  InstantSearch.prototype.beforeBindEvents = function(id) {
    if(!id) id = this.id;
      jQ(document).ready(function() {
          jQ(document).off('submit', '.search-form, #search-form');
      });
  };

  InstantSearchResultItemProduct.prototype.afterRender = function() {
		if (!this.data || !this.isShow) return

    // Discount Tags: Search for discount tags
    let discountTag = this.data.tags.find(element =>element.toLowerCase().includes("discount:"));
    let displayWasIsPrices = false;
    let adjustedPrice = "";
    let disc = '';
    let discountedAmount = '';
    if (discountTag) {
      // Find discount percentage, save as a number
      disc = parseInt( discountTag.toLowerCase().split("discount: ")[1].split("%")[0] );
      discountedAmount = this.data.price_min * disc / 100;
      adjustedPrice = this.data.price_min - discountedAmount;

      if ( disc >= 50) {
        displayWasIsPrices = true;
      } else if ( disc >= 25) {
        displayWasIsPrices = true;
      } else if ( disc >= 20) {
        displayWasIsPrices = true;
      } else if ( disc >= 15) {
        displayWasIsPrices = true;
      } else if ( disc >= 10) {
        displayWasIsPrices = true;
      } else {
        displayWasIsPrices = false;
      }

      if (displayWasIsPrices && adjustedPrice > 0) {
        this.$element.find('.boost-pfs-search-suggestion-product-price').prepend('<span class="product-price__amount--on-sale">' + Utils.formatMoney(adjustedPrice, Globals.moneyFormat) +'</span>')
        this.$element.find('.boost-pfs-search-suggestion-product-regular-price').remove();
      }
	  }
  }

})();